import { render, staticRenderFns } from "./ServersGroup.vue?vue&type=template&id=5a7175c0&scoped=true&"
import script from "./ServersGroup.vue?vue&type=script&lang=js&"
export * from "./ServersGroup.vue?vue&type=script&lang=js&"
import style0 from "./ServersGroup.vue?vue&type=style&index=0&id=5a7175c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7175c0",
  null
  
)

export default component.exports